import axiosInstance from "../../../config/Helpers";

export default async function addToDatabase(data) {
    const response = await axiosInstance.post(
        "affiliate-program/add-store",
        data
    );
    return response.data;
}
